module.exports = __webpack_public_path__ + "static/img/優惠大放送01_300×300.9f1364df.png";